import script from "./PnlViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PnlViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PnlViewer.vue?vue&type=style&index=0&id=2f03ddae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f03ddae"]])

export default __exports__